<template>
  <div style="background: #3A43D8;">
    <div class="content-container joinlamb">
      <div :style="`background-image:url(${imgbc});`" class="txt2">
        <a-row>
          <a-col :span="24">
            <h3>{{ $t("join.h3") }}</h3>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <p class="num">
              10+
            </p>
            <p class="city">
              {{ $t("join.p1") }}
            </p>
          </a-col>
          <a-col :span="8">
            <p class="num">
              30+
            </p>
            <p class="city">
              {{ $t("join.p2") }}
            </p>
          </a-col>
          <a-col :span="8">
            <p class="num">
              100000+
            </p>
            <p class="city">
              {{ $t("join.p3") }}
            </p>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import imgbc from "@/assets/earth.png";

export default {
  components: {},
  data() {
    return {
      imgbc
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@media (max-width: 500px) {
  .joinlamb {
    text-align: center;
    color: white;
    height: 100%;
    .txt2 {
      margin: 0px 10%;
      // background-size: cover;
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: bottom;
      padding-top: 40px;
      padding-bottom: 40px;
    }
    h3 {
      margin-bottom: 30px;
      text-align: center;
      font-size: 24px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 33px;
    }
    .num {
      font-size: 34px;
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
    }
    .city {
      margin: 0;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 28px;
    }
  }
}

@media (min-width: 501px) {
  .joinlamb {
    text-align: center;
    color: white;
    padding-top: 40px;

    .txt2 {
      margin: 0px 10%;
      // background-size: cover;
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: bottom;
      height: 221px;
      padding-top: 20px;
    }
    h3 {
      color: white;
    }
    .num {
      font-size: 30px;
      margin-bottom: 10px;
    }
    .city {
      margin: 0;
    }
  }
}
</style>
